import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  footerActions: {
    borderTop: "2px solid #E6E6E6",
    marginTop: "15px",
    paddingTop: "25px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    "& .Mui-disabled": {
      color: "#666666",
      border: "none",
      "& svg path": {
        fill: "#666666",
      },
    },
    "& .MuiButtonBase-root": {
      marginLeft: "20px",
      "& svg": {
        "& path": {
          fill: "#22D9BB",
        },
      },
    },
    "& .MuiButton-label": {
      textTransform: "initial",
    },
  },
  tipTitle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#0ABF52",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(20),
  },
  actionContainer: {
    width: "100%",
  },
}));
